<template>
    <el-dialog
            width="650px"
            :title="'新增数据集'"
            :close-on-click-modal="false"
            :visible.sync="visible">
        <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmit()"
                 label-width="150px">
            <el-form-item label="数据集分组" prop="ruleGroup">
                {{dataForm.ruleGroup}}
            </el-form-item>
            <el-form-item label="数据集名称" prop="ruleName">
                <el-input v-model="dataForm.ruleName" placeholder="数据集名称"></el-input>
            </el-form-item>
            <el-form-item label="数据集英文名称" prop="ruleEnglishName">
                <el-input v-model="dataForm.ruleEnglishName" placeholder="数据集英文名称"></el-input>
            </el-form-item>
            <el-form-item label="数据集代码" prop="ruleCode">
                <el-input v-model="dataForm.ruleCode" placeholder="数据集代码"></el-input>
            </el-form-item>
            <el-form-item label="数据集表名" prop="tableName">
                <el-input v-model="dataForm.tableName" placeholder="数据集表名"></el-input>
            </el-form-item>
            <el-form-item label="排序" prop="sort">
                <el-input v-model="dataForm.sort" placeholder="排序"></el-input>
            </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" @click="dataFormSubmit()">确定</el-button>
    </span>
    </el-dialog>
</template>

<script>
    export default {
        data() {
            return {
                visible: false,
                dataForm: {
                    ruleGroup: '',
                    ruleName: '',
                    ruleCode: '',
                    ruleEnglishName: '',
                    tableName: '',
                    sort: ''
                },
                dataRule: {
                    ruleName: [
                        {required: true, message: '数据集名称不能为空', trigger: 'blur'}
                    ],
                    ruleCode: [
                        {required: true, message: '数据集代码不能为空', trigger: 'blur'}
                    ],
                    tableName: [
                        {required: true, message: '数据集表名不能为空', trigger: 'blur'}
                    ],
                    ruleEnglishName: [
                        {required: true, message: '数据集英文名称不能为空', trigger: 'blur'}
                    ],
                }
            }
        },
        methods: {
            init(ruleGroup) {
                this.visible = true
                this.$nextTick(() => {
                    this.$refs['dataForm'].resetFields()
                })
                this.dataForm.ruleGroup = ruleGroup
            },
            dataFormSubmit() {
                this.$refs['dataForm'].validate((valid) => {
                    if (valid) {
                        this.$httpReq({
                            url: '/dataset/rule/save',
                            method: 'post',
                            data: {
                                'id': '',
                                'ruleGroup': this.dataForm.ruleGroup,
                                'ruleName': this.dataForm.ruleName,
                                'ruleCode': this.dataForm.ruleCode,
                                'tableName': this.dataForm.tableName,
                                'ruleEnglishName': this.dataForm.ruleEnglishName,
                                'sort': this.dataForm.sort || 10
                            }
                        }).then(({data}) => {
                            if (data && data.code === '1') {
                                this.$message({
                                    message: '操作成功',
                                    type: 'success',
                                    duration: 1500,
                                    onClose: () => {
                                        this.visible = false
                                        this.$emit('refreshDataList')
                                    }
                                })
                            } else {
                                this.$message.error(data.msg)
                            }
                        })
                    }
                })
            }
        }
    }
</script>
